import React, { Component } from 'react';
import './scroll-top.css';

class ScrollToTop extends Component {

  scrollHandler() {
    const yValue = window.innerHeight;
    window.scrollTo({
      top: yValue,
      behavior: 'smooth'
    });
  }

  render() {
    return (
      <div className="upLogoWrapper">
        <img src={require('../assets/down-arrow.png')}
             alt="Down arrow" 
             className="up-logo-img" 
             onClick={this.scrollHandler} />
      </div>
    )
  }
}

export default ScrollToTop;